/**
 * OS-1 · whether a saved worklog bills to NO line item although its task sits on a project — an
 * unidentified hour: every line item that could take it names other people, or names its author
 * for other dates (`worklogSchema.lineItemId`). The hour is saved either way; this is only whether
 * the form should say so.
 *
 * ⚠️ Read off the write's own response rather than asked beforehand: which line item takes an hour
 * is decided by the database when it is written (`0225`), and a guess made before the write is a
 * second copy of that rule.
 */
export function billsNowhere(body: unknown): boolean {
  if (typeof body !== 'object' || body === null) return false;
  const row = body as { readonly lineItemId?: unknown; readonly projectId?: unknown };
  return row.lineItemId === null && typeof row.projectId === 'string';
}
